import React from "react";
import { escape2Html } from "../../util";
import SingleMessage from "./singleMessage.js";
import { Icon, message, Button, Card, Spin, Popover } from "antd";
import { WeaTab, WeaInput, WeaTop, WeaNewScroll, WeaSelect } from "ecCom";
import WeaLocaleProvider from "../../../../ecology9/wea-locale-provider";
const getLabel = WeaLocaleProvider.getLabel;

import * as API from "../../apis/index";

class MsgListPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      syncComponent: () => null
    };
  }
  static scroll = null;
  debounce(fn, wait) {
    var last = null;
    const context = this;
    var timer = null;
    return function() {
      const args = arguments;
      clearTimeout(timer);
      var now = new Date();
      if (!last) {
        last = now;
      }
      if (now - last >= wait) {
        fn.apply(context, args);
        last = now;
      } else {
        timer = setTimeout(function() {
          fn.apply(context, args);
        }, wait);
      }
    };
  }
  updateSyncCom(com) {
    this.setState(
      {
        syncComponent: com
      },
      () => {
        console.log(this.state.syncComponent);
        this.forceUpdate();
        console.log("force");
      }
    );
  }

  renderList() {
    let leftScrollHeight =
      this.props.offsetHeight === 0 ? 618 : 618 + this.props.offsetHeight - 80;
    if (this.props.unReadMsgValue === "block") {
      // leftScrollHeight -= 25;
    }
    if (this.props.tabFlag === "1") {
      leftScrollHeight -= 48;
    }
    return (
      <React.Fragment>
        {/* 顶部点击 */}
        <div
          className="wea-messageCenter-stickyinfo"
          style={{ display: "none" || this.props.unReadMsgValue }}
        >
          <div style={{ float: "left", "margin-right": "10px" }}>
            <a
              onClick={() => {
                this.props.setState({ flag: false });
                this.props.getMsgList(
                  this.props.current,
                  this.props.msgid,
                  this.props.mintime
                );
              }}
            >
              <Icon className="icon" type="exclamation-circle" />
              {getLabel("504399", "你还有尚未读的消息,请点击阅读")}
            </a>
          </div>

          <div style={{ float: "right" }}>
            <a
              onClick={() => {
                API.setMsgRead({ allReadFlag: 1 }).then(res => {
                  if (res) {
                    this.props.getMsgTypeList();
                  }
                });
                this.props.setState({
                  unReadMsgValue: "none"
                });
              }}
            >
              全部置为已读
            </a>
          </div>
        </div>
        {/* 顶部 tips 出现时的 占位符 */}
        {/* {this.state.unReadMsgValue === "block" && (
                <div style={{ height: 25 }} />
              )} */}
        {/* 提醒有该tab */}
        <div
          style={{
            display: this.props.tabFlag === "1" ? "block" : "none"
          }}
          className="sticky-top-tab"
        >
          <WeaTab
            datas={this.props.tabData}
            keyParam="viewcondition" //主键
            countParam="groupid" //数量
            selectedKey={this.props.tabSelectedKey}
            onChange={v => {
              const currentArray = this.props.tabData.filter(
                item => item.viewcondition == v
              );
              !this.props.loading &&
                this.props.setState(
                  {
                    tabSelectedKey: v,
                    refresh: true,
                    selectState: currentArray ? currentArray[0].selectState : ""
                  },
                  () => {
                    this.props.getMsgList(
                      this.props.current,
                      0,
                      0,
                      null,
                      true,
                      true,
                      "",
                      false,
                      true
                    );
                  }
                );
            }}
          />
        </div>
        {this.props.tabFlag === "1" && <div style={{ height: 48 }} />}

        <WeaNewScroll
          ref={e => {
            this.props.scroll(e);
            this.scroll = e;
          }}
          height={leftScrollHeight}
          style={{ marginLeft: "-10px" }}
          onScroll={this.debounce(function(e) {
            const position = e.target && e.target.scrollTop;
            this.props.getReadedMsg(position);
          }, 200)}
          // onScroll={e => {
          //   const position = e.target.scrollTop;
          //   this.getReadedMsg(position);
          //   if (e.target.scrollTop === 0 && !this.state.loading) {
          //     this.setState({ flag: false });
          //     this.getMsgList(
          //       this.state.current,
          //       this.state.msgid,
          //       this.state.mintime
          //     );
          //   }
          // }}
        >
          {this.props.msgList.length === 0 && !this.props.loading ? (
            <div className="wea-messageCenter-nomsg">
              <div className="nomsg-container">
                <span style={{ fontSize: 80 }}>
                  <i className="icon-coms-blank" />
                </span>
                <br />
                <span className="wea-f12">{getLabel("83553", "暂无消息")}</span>
              </div>
            </div>
          ) : (
            <div className="click-look-more">
              <span>
                {this.props.loading ? (
                  <Icon type="loading" />
                ) : (
                  <React.Fragment>
                    {this.props.newGetMsgList.length > 0 ? (
                      <span
                        onClick={() => {
                          this.props.getMsgList(
                            this.props.current,
                            this.props.msgid,
                            this.props.mintime,
                            null,
                            true,
                            false
                          );
                        }}
                      >
                        <Icon type="clock-circle-o" />
                        <a className="wea-f12" href="javascript:void(0);">
                          {getLabel("384653", "点击加载更多")}
                        </a>
                      </span>
                    ) : (
                      <span className="wea-f12" className="no-more">
                        {getLabel("390064", "没有更多啦")}
                      </span>
                    )}
                  </React.Fragment>
                )}
              </span>
            </div>
          )}
          {this.props.msgList.length > 0 &&
            this.props.msgList.map(data => {
              return (
                <SingleMessage
                  {...data}
                  imgSrc={data.showimage || ""}
                  name={data.name || ""}
                  time={data.time || ""}
                  link={data.link || ""}
                  title={data.title || ""}
                  context={data.context || ""}
                  updateSyncCom={com => this.updateSyncCom(com)}
                />
              );
            })}
        </WeaNewScroll>
        <div
          className="wea-messageCenter-stickyinfo"
          style={{
            display: this.props.newMsgValue
          }}
          onClick={() => {
            this.props.getNewMsgList(
              this.props.current,
              this.props.maxtime,
              1,
              () => {
                if (this.props.current !== "0") {
                  this.props.setMsgRead();
                }
                this.scroll.refs.weaBaron.scrollToLast();
              }
            );
          }}
        >
          <div
            className="bottom-left-title"
            dangerouslySetInnerHTML={{
              __html: escape2Html(
                this.props.messagetype + " " + this.props.title
              )
            }}
          />
          <div style={{ float: "right" }}>
            <a
              style={{
                "border-style": "none",
                cursor: "pointer",
                "background-color": "	#BBDBF9"
              }}
            >
              {this.props.count}
              {getLabel("126991", "条新消息")}
            </a>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderCustom() {
    const { currentMsgType } = this.props;
    if (!currentMsgType[0] || !currentMsgType[0].pc_url) {
      return <span style={{ color: "#f00" }}>组件错误！</span>;
    }
    return (
      <React.Fragment>
        <iframe width="100%" height="100%" src={currentMsgType[0].pc_url} />
      </React.Fragment>
    );
  }

  render() {
    let isCustom = false;
    const { currentMsgType } = this.props;
    if (currentMsgType[0] && currentMsgType[0].pc_url) {
      isCustom = true;
    }
    return (
      <div className="wea-messageCenter-leftList">
        <this.state.syncComponent />
        {isCustom ? this.renderCustom() : this.renderList()}
      </div>
    );
  }
}

export default MsgListPanel;



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/components/message-center/msg-list-panel.js